export const vehicle_details_best_for = 'Best for sending:';

export const service_category_trucks = 'trucks';
export const service_category_two_wheelers = 'two wheeler';
export const service_category_2w = 'two wheelers';

export const packers_and_movers = 'packers and movers';

export const heightToShowGetEstimateStickyFrom = 700;
